module.exports = __webpack_public_path__ + "static/banner-mobile-9d7dbfa29269fe436b40cef9cedf2ff1.png";